import type { ThemeVars } from '@cbhq/cds-common/core/theme';

/**
 * Layout constants for consistent container widths across the application
 * Based on Figma design specifications
 */

/** Single column container width (no sidebar) */
export const SINGLE_COLUMN_MAX_WIDTH = 960;

/** Two column container width (with sidebar) */
export const TWO_COLUMN_MAX_WIDTH = 1376;

/** Default sidebar width in two-column layouts */
export const DEFAULT_SIDEBAR_WIDTH = 376;

/** Default page margins on mobile: 16px */
export const DEFAULT_MARGIN_MOBILE: ThemeVars.Space = 2;

/** Default page margins on desktop: 32px */
export const DEFAULT_MARGIN: ThemeVars.Space = 4;

/** Default spacing between cards: 16px */
export const DEFAULT_CARD_SPACER: ThemeVars.Space = 2;

/** Default card styling */
export const CARD_BORDER_RADIUS = 300;
export const CARD_PADDING_Y: ThemeVars.Space = 3;
export const CARD_PADDING_X: ThemeVars.Space = 3;
export const CARD_GAP: ThemeVars.Space = 2;

/** Default padding for card headers */
export const CARD_HEADER_PADDING_Y: ThemeVars.Space = 2;
export const CARD_HEADER_PADDING_X: ThemeVars.Space = 3;

/** Nested card styling (cards within cards) */
export const NESTED_CARD_BORDER_RADIUS = 200;
export const NESTED_CARD_PADDING: ThemeVars.Space = 2;
export const NESTED_CARD_GAP: ThemeVars.Space = 1;
